import React, { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { subscribeToPush, unsubscribeFromPush, isCurrentlySubscribed, getPushPermissionState } from "../lib/push";

export default function PushToggle() {
  const [subscribed, setSubscribed] = useState(false);
  const [permission, setPermission] = useState("default");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    isCurrentlySubscribed().then(setSubscribed);
    getPushPermissionState().then(setPermission);
  }, []);

  const toggle = async () => {
    setBusy(true); setMsg("");
    if (subscribed) {
      await unsubscribeFromPush();
      setSubscribed(false);
      setMsg("Browser-Benachrichtigungen deaktiviert.");
    } else {
      const r = await subscribeToPush();
      if (r.ok) {
        setSubscribed(true);
        setMsg("Browser-Benachrichtigungen aktiv!");
      } else if (r.reason === "denied") {
        setMsg("Erlaubnis verweigert. Bitte in den Browser-Einstellungen erlauben.");
      } else {
        setMsg("Push wird in diesem Browser nicht unterstützt.");
      }
    }
    setBusy(false);
    setPermission(await getPushPermissionState());
  };

  if (permission === "unsupported") return null;

  return (
    <div className="falke-card p-5 flex items-center gap-4" data-testid="push-toggle-card">
      <div className={`w-10 h-10 rounded-full flex items-center justify-center ${subscribed ? "bg-falke-success/15 text-falke-success" : "bg-falke-blue/10 text-falke-blue"}`}>
        {subscribed ? <Bell size={18} /> : <BellOff size={18} />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-falke-blue">Browser-Push-Benachrichtigungen</div>
        <div className="text-xs text-falke-anthracite/65 mt-0.5">{subscribed ? "Du wirst über FalkeCoin-Gutschriften, Status-Updates und neue Empfehlungen benachrichtigt." : "Aktivieren, um Echtzeit-Updates zu erhalten."}</div>
        {msg && <div className="text-xs text-falke-blue mt-1">{msg}</div>}
      </div>
      <button onClick={toggle} disabled={busy} className={subscribed ? "btn-outline !py-2 text-sm" : "btn-primary !py-2 text-sm"} data-testid="push-toggle-btn">
        {busy ? "..." : subscribed ? "Deaktivieren" : "Aktivieren"}
      </button>
    </div>
  );
}
